import React, { useState } from 'react';

const WelcomeSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    course: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    alert('Enquiry sent successfully!');
    setFormData({ name: '', email: '', phone: '', course: '', message: '' });
  };

  return (
    <div className="bg-blue-50 py-12"> {/* Blue background for the whole section */}
      <div className="container mx-auto px-4">
        {/* Flex container with equal height columns */}
        <div className="flex flex-col md:flex-row md:items-stretch gap-8 md:gap-12">
          
          {/* Left side - Welcome Text (white card) */}
          <div className="md:w-1/2 bg-white rounded-lg shadow-md p-6 flex flex-col justify-between">
            <div>
              <h1 className="text-3xl md:text-4xl font-bold text-blue-800 mb-6">
                Welcome To R.D.S.Snatkottar Mahavidyalaya
              </h1>
              <div className="text-gray-600 leading-relaxed space-y-4">
                <p>
                  Education is necessary for human beings like other necessities
                  e.g. as food, clothes and residence. Due to the lack of education,
                  humans behave like animals.
                </p>
                <p>
                  Since learning process is continued from cradle to grave, during
                  this span human beings continue to learn from nature, natural events,
                  different behaviours of human and other creatures.
                </p>
                <p>
                  In this process human get knowledge about nation, society, family
                  and self responsibilities by some intellectuals to whom we call
                  teachers.
                </p>
              </div>
            </div>

            {/* Extra content: key highlights */}
            <div className="mt-8 pt-6 border-t border-blue-200">
              <h3 className="text-xl font-semibold text-blue-800 mb-3">
                Why Choose Us?
              </h3>
              <ul className="space-y-2 text-gray-600">
                <li className="flex items-start">
                  <svg className="w-5 h-5 text-blue-600 mr-2 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  Experienced Faculty & Modern Infrastructure
                </li>
                <li className="flex items-start">
                  <svg className="w-5 h-5 text-blue-600 mr-2 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  Industry-Ready Curriculum
                </li>
                <li className="flex items-start">
                  <svg className="w-5 h-5 text-blue-600 mr-2 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  Placement Assistance & Career Guidance
                </li>
                <li className="flex items-start">
                  <svg className="w-5 h-5 text-blue-600 mr-2 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  State-of-the-Art Labs & Library
                </li>
              </ul>
            </div>
          </div>

          {/* Right side - Enquiry Form (white card) */}
          <div className="md:w-1/2 bg-white rounded-lg shadow-md p-6 flex flex-col">
            <h2 className="text-2xl font-semibold text-blue-800 mb-4">
              Enquiry Form
            </h2>
            <form onSubmit={handleSubmit} className="flex-grow space-y-4">
              <div>
                <label htmlFor="name" className="block text-gray-700 font-medium mb-1">
                  Full Name *
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="Enter your full name"
                />
              </div>

              <div>
                <label htmlFor="email" className="block text-gray-700 font-medium mb-1">
                  Email Address *
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="you@example.com"
                />
              </div>

              <div>
                <label htmlFor="phone" className="block text-gray-700 font-medium mb-1">
                  Phone Number *
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="+91 12345 67890"
                />
              </div>

              <div>
                <label htmlFor="course" className="block text-gray-700 font-medium mb-1">
                  Course of Interest
                </label>
                <select
                  id="course"
                  name="course"
                  value={formData.course}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value="">Select a course</option>
                  <option value="BA">Bachelor of Arts (BA)</option>
                  <option value="BSc">Bachelor of Science (BSc)</option>
                  <option value="BCom">Bachelor of Commerce (BCom)</option>
                  <option value="MA">Master of Arts (MA)</option>
                  <option value="MSc">Master of Science (MSc)</option>
                  <option value="MCom">Master of Commerce (MCom)</option>
                </select>
              </div>

              <div>
                <label htmlFor="message" className="block text-gray-700 font-medium mb-1">
                  Message / Query
                </label>
                <textarea
                  id="message"
                  name="message"
                  rows="3"
                  value={formData.message}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="Your message here..."
                />
              </div>

              <button
                type="submit"
                className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-lg transition duration-200"
              >
                Submit Enquiry
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeSection;